import type { ReactNode } from "react";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { ProgressBar } from "./ProgressBar";

interface ContentContainerProps {
  children: ReactNode;
  customMarginTop?: string;
  progress?: {
    currentStep: number;
    totalSteps: number;
  };
  subtitle?: ReactNode;
  title?: ReactNode;
}

const CONTENT_CONTAINER_MAX_WIDTH = {
  mobile: "max-w-[450px]",
  tablet: "md:max-w-2xl",
  desktop: "lg:max-w-2xl",
  wide: "xl:max-w-lg",
};

const CONTENT_CONTAINER_MARGIN_TOP = {
  mobile: "mt-2",
  tablet: "md:mt-12",
  desktop: "md:mt-12",
  wide: "xl:mt-16",
};

export const ContentContainer = ({
  children,
  title,
  subtitle,
  progress,
  customMarginTop,
}: ContentContainerProps) => (
  <div
    className={classNames(
      "mx-auto w-full",
      ...Object.values(CONTENT_CONTAINER_MAX_WIDTH),
      ...(customMarginTop
        ? [customMarginTop]
        : Object.values(CONTENT_CONTAINER_MARGIN_TOP)),
    )}
  >
    {progress && (
      <div className="mb-6 flex justify-start">
        <ProgressBar {...progress} />
      </div>
    )}
    {(title || subtitle) && (
      <div className="mb-8">
        {title && (
          <Typography.TitleXl leading="leading-1">{title}</Typography.TitleXl>
        )}
        {subtitle && (
          <div className="mt-2">
            <Typography.BodyMd color="text-light">{subtitle}</Typography.BodyMd>
          </div>
        )}
      </div>
    )}
    {children}
  </div>
);
